import React from 'react';
import styled from 'styled-components';
import whiteShelfImg from 'assets/booths/white-shelf.png';

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const WhiteShelf = () => (
  <StyledImg src={whiteShelfImg} />
);

export default WhiteShelf;
